module.exports = __webpack_public_path__ + "static/media/ic-right-slider-blue.0bf7d212.svg";